var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-container",class:{'is-collapse': _vm.isCollapse}},[_c('div',{staticClass:"logo-1"},[_c('img',{attrs:{"src":_vm.logo1}})]),(!_vm.isCollapse)?_c('div',{staticClass:"logo-2"},[_c('img',{attrs:{"src":_vm.logo2}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }